import useUnmount from './useUnmount';
function useWindowResize(func) {
    window.addEventListener('resize', func);
    useUnmount(function () {
        window.removeEventListener('resize', func);
    });
}
export default useWindowResize;
